// Prefijo de los ids de alerta de unidades externas.
//
// Vive en un módulo propio, y no inline en MapV2.vue, porque el prefijo se
// usa en tres lugares (generación, remoción por WS, remoción local tras
// descartar) y porque es peligrosamente parecido al de external_sensor:
// 'external-device-alert-' vs 'external-sensor-alert-' comparten los
// primeros 9 caracteres.
export const EXTERNAL_DEVICE_ALERT_PREFIX = 'external-device-alert-'

export function externalDeviceAlertId(id) {
  if (id === null || id === undefined || id === '') return null
  return EXTERNAL_DEVICE_ALERT_PREFIX + id
}
